// PrivacyPolicy.js
import React from 'react';
import {
  ChakraProvider,
  Box,
  Heading,
  Text,
  VStack,
  Button,
  Link,
} from '@chakra-ui/react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ArrowBackIcon } from '@chakra-ui/icons';

const PrivacyPolicy = () => {
  return (
    <ChakraProvider>
      <Box
        display={'flex'}
        w={['95%', null, null, null, '50%']}
        mr={['2.5%', null, null, null, '25%']}
        alignItems={'center'}
        justifyContent={'flex-start'}
      >
        <Link as={ReactRouterLink} to={'/'}>
          <Button
            color={'#242424'}
            alignSelf={'flex-end'}
            aria-label="Inicio"
            leftIcon={<ArrowBackIcon />}
            bgColor={'transparent'}
          >
            Volver
          </Button>
        </Link>
      </Box>
      <Box w={['90%', null, null, null, '50%']} mx="auto" mt="4" pb="8">
        <Heading mb="4">Política de Privacidad de RouteForecast.app</Heading>
        <Text fontSize="sm" color="gray.600" mb="6">
          Última actualización: 28 de enero de 2026
        </Text>

        {/* Secciones de la política de privacidad */}
        <VStack align="start" spacing="6">
          <Text>
            <strong>1. Responsable del Tratamiento</strong>
            <br />
            <strong>Identidad:</strong> Pablo Osés Andía
            <br />
            <strong>Domicilio:</strong> Calle Rosario Romero 8 1B, 28029 Madrid,
            España
            <br />
            <strong>DNI:</strong> Disponible bajo requerimiento legal
            <br />
            <strong>Correo electrónico:</strong>{' '}
            <a href="mailto:pablo98oses@gmail.com">pablo98oses@gmail.com</a>
            <br />
            <strong>Sitio web:</strong> RouteForecast.app
          </Text>

          <Text>
            <strong>2. Información Recopilada</strong>
            <br />
            <strong>2.1. Información que proporcionas voluntariamente:</strong>
            <br />
            - Dirección de correo electrónico si te suscribes a nuestro boletín
            <br />
            - Información de contacto si nos envías consultas
            <br />
            <br />
            <strong>2.2. Información recopilada automáticamente:</strong>
            <br />
            - Dirección IP
            <br />
            - Tipo de navegador y sistema operativo
            <br />
            - Páginas visitadas y tiempo de permanencia
            <br />
            - Ubicación aproximada (ciudad/país)
            <br />
            - Rutas de origen y destino introducidas en la aplicación
            <br />- Interacciones con el mapa y consultas meteorológicas
          </Text>

          <Text>
            <strong>3. Uso de la Información</strong>
            <br />
            Utilizamos la información recopilada para:
            <br />
            - Proporcionar y mejorar nuestros servicios de pronóstico
            meteorológico
            <br />
            - Analizar el uso del sitio web mediante Google Analytics
            <br />
            - Personalizar la experiencia del usuario
            <br />
            - Mostrar publicidad relevante a través de Google AdSense
            <br />
            - Responder a consultas y proporcionar soporte técnico
            <br />- Cumplir con obligaciones legales
          </Text>

          <Text>
            <strong>4. Base Legal del Tratamiento (RGPD)</strong>
            <br />
            El tratamiento de datos se basa en:
            <br />- <strong>Consentimiento:</strong> Para cookies analíticas y
            publicitarias
            <br />- <strong>Interés legítimo:</strong> Para análisis estadístico
            y mejora del servicio
            <br />- <strong>Ejecución de contrato:</strong> Para proporcionar el
            servicio solicitado
          </Text>

          <Text>
            <strong>5. Compartición de Datos con Terceros</strong>
            <br />
            Compartimos información con los siguientes terceros:
            <br />
            <br />
            <strong>5.1. Google Analytics:</strong> Para análisis de tráfico y
            comportamiento
            <br />
            <strong>5.2. Google AdSense:</strong> Para mostrar publicidad
            personalizada
            <br />
            <strong>5.3. AEMET:</strong> Para obtener datos meteorológicos (no
            compartimos datos de usuario)
            <br />
            <br />
            Estos servicios pueden transferir datos fuera del Espacio Económico
            Europeo. Google LLC cumple con el Marco de Privacidad de Datos
            UE-EE.UU.
          </Text>

          <Text>
            <strong>6. Cookies y Tecnologías de Seguimiento</strong>
            <br />
            Utilizamos las siguientes categorías de cookies:
            <br />
            <br />
            <strong>6.1. Cookies Técnicas (Necesarias):</strong> Esenciales para
            el funcionamiento del sitio
            <br />
            <strong>6.2. Cookies Analíticas:</strong> Google Analytics para
            estadísticas
            <br />
            <strong>6.3. Cookies Publicitarias:</strong> Google AdSense para
            mostrar anuncios
            <br />
            <br />
            Para más información, consulta nuestra{' '}
            <Link
              as={ReactRouterLink}
              to="/cookies"
              color="blue.500"
              textDecoration="underline"
            >
              Política de Cookies
            </Link>
            .
          </Text>

          <Text>
            <strong>7. Derechos de los Usuarios (RGPD)</strong>
            <br />
            Tienes derecho a:
            <br />- <strong>Acceso:</strong> Solicitar información sobre tus
            datos personales
            <br />- <strong>Rectificación:</strong> Corregir datos inexactos
            <br />- <strong>Supresión:</strong> Solicitar la eliminación de tus
            datos
            <br />- <strong>Oposición:</strong> Oponerte al tratamiento de datos
            <br />- <strong>Portabilidad:</strong> Recibir tus datos en formato
            estructurado
            <br />- <strong>Limitación:</strong> Limitar el procesamiento de tus
            datos
            <br />- <strong>Retirar consentimiento:</strong> En cualquier
            momento
            <br />
            <br />
            Para ejercer estos derechos, contacta: pablo98oses@gmail.com
            <br />
            También puedes presentar una reclamación ante la Agencia Española de
            Protección de Datos (AEPD).
          </Text>

          <Text>
            <strong>8. Retención de Datos</strong>
            <br />
            - Datos analíticos: 26 meses (Google Analytics)
            <br />
            - Cookies publicitarias: Según configuración del usuario
            <br />
            - Consultas por correo: Hasta resolución + 1 año
            <br />- Datos de suscripción: Hasta que retires el consentimiento
          </Text>

          <Text>
            <strong>9. Seguridad de la Información</strong>
            <br />
            Implementamos medidas técnicas y organizativas para proteger tus
            datos:
            <br />
            - Cifrado HTTPS en toda la comunicación
            <br />
            - Acceso restringido a datos personales
            <br />
            - Revisiones periódicas de seguridad
            <br />- Cumplimiento de estándares de la industria
          </Text>

          <Text>
            <strong>10. Menores de Edad</strong>
            <br />
            Este sitio web no está dirigido a menores de 16 años. No recopilamos
            conscientemente información de menores. Si eres padre/madre y
            descubres que tu hijo/a nos ha proporcionado información, contacta
            con nosotros.
          </Text>

          <Text>
            <strong>11. Enlaces a Sitios Externos</strong>
            <br />
            Nuestro sitio puede contener enlaces a sitios web de terceros
            (AEMET, Google, etc.). No somos responsables de las prácticas de
            privacidad de estos sitios. Te recomendamos revisar sus políticas de
            privacidad.
          </Text>

          <Text>
            <strong>12. Transferencias Internacionales</strong>
            <br />
            Algunos servicios de terceros (Google) pueden transferir datos fuera
            del EEE. Estas transferencias se realizan bajo garantías adecuadas
            (cláusulas contractuales tipo, Marco de Privacidad de Datos
            UE-EE.UU.).
          </Text>

          <Text>
            <strong>13. Cambios en la Política de Privacidad</strong>
            <br />
            Nos reservamos el derecho de actualizar esta política. Los cambios
            significativos se notificarán mediante aviso en el sitio web. La
            fecha de última actualización se muestra al inicio del documento.
          </Text>

          <Text>
            <strong>14. Contacto y Delegado de Protección de Datos</strong>
            <br />
            Para cualquier pregunta sobre esta política o ejercer tus derechos:
            <br />
            Email:{' '}
            <a href="mailto:pablo98oses@gmail.com">pablo98oses@gmail.com</a>
          </Text>
        </VStack>

        <Box mt="8" p="4" bg="gray.50" borderRadius="md">
          <Text fontSize="sm">
            Al utilizar RouteForecast.app, aceptas esta Política de Privacidad y
            nuestras{' '}
            <Link
              as={ReactRouterLink}
              to="/terminos"
              color="blue.500"
              textDecoration="underline"
            >
              Condiciones de Uso
            </Link>
            . Para gestionar tus preferencias de cookies, consulta nuestra{' '}
            <Link
              as={ReactRouterLink}
              to="/cookies"
              color="blue.500"
              textDecoration="underline"
            >
              Política de Cookies
            </Link>
            .
          </Text>
        </Box>
      </Box>
    </ChakraProvider>
  );
};

export default PrivacyPolicy;
